import {Helmet} from '@dr.pogodin/react-helmet';

import i18n from '@dms/i18n';
import {settingsRoutes} from '@dms/routes';
import {SettingsTemplate} from '@dms/settings/shared';
import {formatDocumentTitle} from '@dms/shared';

import {GeneralAdvertisementPlatforms} from './components/GeneralAdvertisementPlatforms';

export function AdvertisingPlatforms() {
  return (
    <>
      <Helmet
        title={formatDocumentTitle(
          i18n.t('page.settings.labels.advertisementPlatform'),
          i18n.t('page.salesSettings.labels.advertising'),
          i18n.t('page.settings.labels.title')
        )}
      />
      <SettingsTemplate
        header={{
          title: i18n.t('page.settings.labels.advertisementPlatform'),
          breadcrumbs: [
            {
              label: i18n.t('page.salesSettings.labels.advertising'),
              href: settingsRoutes.advertising,
            },
          ],
        }}
        description={i18n.t('page.settings.labels.platformDescription')}
        data-testid="settings-advertising-platforms"
      >
        <GeneralAdvertisementPlatforms />
      </SettingsTemplate>
    </>
  );
}
